import React from "react";
import FinanceCategoryFormModal from "@features/admin/finance/category/components/FinanceCategoryFormModal";

const CreateFinanceCategoryModal: React.FC<{ show: boolean; onHide: () => void; onChanged?: () => void }> = ({ show, onHide, onChanged }) => (
    <FinanceCategoryFormModal
        show={show}
        onHide={onHide}
        category={null}
        onSaved={onChanged}
        testId="create-finance-category-modal"
    />
);

export default CreateFinanceCategoryModal;
